module.exports = __webpack_public_path__ + "static/flags/KN-52ba9af3597db132bfd8364c44a512fc.gif";